import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    wrapper: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    }),
    paymentPlanColumnTitle: css({
        ...(isHosTheme && { fontWeight: 500 }),
    }),
    paymentPlanLineItems: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        ...(isHosTheme && {
            border: `0.5px solid ${theme.palette.secondary.dark}`,
            borderRadius: theme.custom.borderRadius[23],
            padding: '30px 20px',
            backgroundColor: theme.palette.common.white,
        }),
    }),
    noBorder: css({
        [theme.breakpoints.down('lg')]: {
            border: 'none !important',
            padding: '10px 0px !important',
        },
    }),
    tableRow: css({
        display: 'flex',
        gap: '15px',
        paddingBottom: '10px',
    }),
    tableRowWithBorder: css({
        borderBottom: `1px solid ${theme.palette.grey[600]}`,
        alignItems: 'baseline',
        ...(isHosTheme && {
            borderBottom: `0.5px solid ${theme.palette.primary.main}`,
        }),
    }),
    tableRowWithDarkBorder: css({
        ...(isHosTheme && {
            borderColor: theme.palette.secondary.dark,
        }),
    }),
    tableRowTotal: css({
        paddingBlock: '10px',
        borderTop: isHosTheme ? 'none' : `1px solid ${theme.palette.grey[600]}`,
        borderBottom: `1px solid ${isHosTheme ? theme.palette.primary.main : theme.palette.grey[600]}`,
    }),
    tableRowDiscount: css({
        color: theme.palette.success.dark,
    }),
    firstCell: css({
        flex: 3,
        textAlign: 'left',
        display: 'flex',
        alignItems: 'center',
        gap: '7px',
        ...(isHosTheme && {
            fontWeight: 500,
        }),
    }),
    twoRows: css({
        flex: 'none',
    }),
    totalPay: css({
        [theme.breakpoints.down('sm')]: {
            fontSize: '19px',
        },
        ...(isHosTheme && {
            fontSize: '16px',
            fontWeight: 500,
        }),
    }),
    totalPayAmount: css({
        ...(isHosTheme && {
            fontSize: '22px',
            fontWeight: 700,
        }),
    }),
    secondCell: css({
        flex: 1,
        textAlign: 'left',
        minWidth: '60px',
        ...(isHosTheme && {
            fontWeight: 500,
        }),
    }),
    thirdCell: css({
        flex: 3,
        textAlign: 'right',
        ...(isHosTheme && {
            fontWeight: 500,
        }),
    }),
    cta: css({
        borderRadius: '100px',
        paddingBlock: '16px',
        width: '100%',
        alignSelf: 'center',
        margin: '30px 0 40px 0',
        order: 1,
        [theme.breakpoints.up('lg')]: {
            order: 2,
            width: '190px',
        },
    }),

    tableContent: css({
        ...(isHosTheme && {
            fontSize: '16px',
            fontWeight: 400,
            color: theme.palette.secondary.dark,
        }),
    }),

    discountLine: css({
        ...(isHosTheme && {
            fontSize: '16px',
            fontWeight: 400,
            color: theme.palette.success.main,
        }),
    }),

    mobilePaymentPlan: css({
        width: '100%',
        border: `1px solid ${theme.palette.grey[600]}`,
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',

        ...(isHosTheme && {
            border: `0.5px solid ${theme.palette.secondary.dark}`,
            borderRadius: theme.custom.borderRadius[23],
            backgroundColor: theme.palette.common.white,
        }),
    }),

    mobilePaymentPlanWrapper: css({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
        ...(isHosTheme && { gap: '10px' }),
    }),

    mobilePaymentPlanInfoRow: css({
        width: '100%',
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'space-between',
    }),

    mobilePaymentPlanColumnTitle: css({
        ...(isHosTheme && { fontSize: '14px' }),
    }),

    fullPLan: css({
        textDecoration: 'underline',
        color: theme.palette.customBlue,
        cursor: 'pointer',
    }),
    collapseWrapper: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginTop: '25px',
    }),
    detailedPaymentExpanded: css({
        transform: 'rotate(180deg)',
    }),
    discount: css({
        color: theme.palette.success.main,
    }),
    gapWeekRow: css({
        display: 'flex',
        textAlign: 'left',
    }),
    gapWeekText: css({
        fontStyle: 'italic',
        margin: '12px 0',
        ...(isHosTheme && {
            fontStyle: 'normal',
            fontSize: '12px',
            color: theme.palette.secondary.dark,
        }),
    }),
    gapWeekSpan: css({
        color: theme.palette.primary.main,
    }),
};
